/**
 * 商品管理-商品子类别-新增/编辑
 */
// import reg from '../reg.js'

function goodsManagerCategoriesAdd (context) {
  return {
    mainForm: {
      shop_id: [{ required: true, message: context.$t('text.required'), trigger: 'blur' }],
      name: [{ required: true, message: context.$t('text.required'), trigger: 'blur' }],
      name_en: [{ required: true, message: context.$t('text.required'), trigger: 'blur' }],
      compulsory_items: [{ required: true, message: context.$t('text.required'), trigger: 'blur' }]
    }
  }
}

export default goodsManagerCategoriesAdd
